
import Vue from 'vue'
import SwitchLocale from '@/components/SwitchLocale.vue'
import { passwordApi } from '@/api/auth/password'
import isEmailValid from '@/utils/email'
import snackbarStore from '@/store/snackbarStore'

export default Vue.extend({
  name: 'RequestPasswordReset',
  components: {
    SwitchLocale,
  },
  data: () => ({
    email: undefined as string | undefined,
    canSend: false,
    sending: false,
    sent: false,
  }),
  methods: {
    emailRule(v: string) {
      return isEmailValid(v) || this.$t('password.error.invalid-email')
    },
    async sendEmail() {
      if ((this.$refs.email as HTMLFormElement).validate() && this.email) {
        this.sending = true
        try {
          await passwordApi.sendEmail(this.email)
          this.sent = true
        } catch (e) {
          snackbarStore.setSnackbar({ text: this.$t('error.sending') as string, color: 'error' })
        }
        this.sending = false
      }
    },
    back() {
      this.email = undefined
      this.sent = false
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
})
